import * as React from 'react'
import type { SvgIconProps } from '@mui/material'
import { BaseIcon } from '../BaseIcon'
export const WarningIcon = (props: SvgIconProps) => (
  <BaseIcon fill="none" {...props}>
    <path fill="currentColor" d="M13 15V9h-2v6zM13 18v-2h-2v2z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M23.723 21.5 12 .984.277 21.5zm-3.446-2H3.723L12 5.016z"
      clipRule="evenodd"
    />
  </BaseIcon>
)
